import React from 'react';

import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from 'react-google-maps';

import './style.scss';

class Maps extends React.Component {
  createMarkers(markers) {
    // const customMarker = {
    //   path: 'M0-48c-9.8 0-17.7 7.8-17.7 17.4 0 15.5 17.7 30.6 17.7 30.6s17.7-15.4 17.7-30.6c0-9.6-7.9-17.4-17.7-17.4z',
    //   fillColor: '#FF5E62',
    //   fillOpacity: 1,
    //   scale: 0.8,
    //   strokeWeight: 0,
    //   anchor: new google.maps.Point(0, 0),
    //   labelOrigin: new google.maps.Point(0, -30)
    // };
    // markers.push({
    //   title: 'Test',
    //   id: 0,
    //   type: 'Test',
    //   lat: '40.725031',
    //   lng: '-73.252430',
    //   address: 'Test'
    // });
    return markers.map((marker) => {
      const label = {
        text: marker.id.toString(),
        color: 'white',
        fontSize: '16px',
      };

      if (marker.noLabel) {
        return <Marker key={marker.id} position={{ lat: parseFloat(marker.lat), lng: parseFloat(marker.lng) }} />;
      }
      return <Marker key={marker.id} position={{ lat: parseFloat(marker.lat), lng: parseFloat(marker.lng) }} label={label}  />;
    });
  }

  render() {
    const lat = parseFloat(this.props.lat);
    const lng = parseFloat(this.props.lng);
    const zoom = parseFloat(this.props.zoom);
    const { markers } = this.props;

    const mapStyles = require('./mapStyle.json');

    const MyMapComponent = withScriptjs(
      withGoogleMap(() => (
        <GoogleMap
          defaultZoom={zoom}
          defaultCenter={{ lat, lng }}
          defaultOptions={{ styles: mapStyles, disableDefaultUI: true }}
        >
          {this.createMarkers(markers)}
          {/* {props.isMarkerShown && <Marker position={{ lat, lng }} />} */}
        </GoogleMap>
      )),
    );

    return (
      <section className="text-center" id="Maps">
        <div className="row no-gutters">
          <div className="col-lg-12">
            <MyMapComponent
              isMarkerShown
              googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyAsjHpeTBqxSV4rO5xA9XFv6qmqoQilD0M&v=3.exp&libraries=geometry,drawing,places"
              loadingElement={<div style={{ height: '100%' }} />}
              containerElement={<div style={{ height: '400px' }} />}
              mapElement={<div style={{ height: '100%' }} />}
            />
          </div>
        </div>
      </section>
    );
  }
}

export default Maps;
